<template>

    <v-container justify-start>
      <span><router-link :to="{name:'Проекты'}">Проекты</router-link></span> <span>/<b> Вопросы и ответы </b></span>

      <v-divider class="mt-3"></v-divider>

      <h2> Частые вопросы и ответы </h2>



    </v-container>
</template>

<script>

export default {
   components:{
  },
    created () {
    },
    mounted () {
    },
    computed: {
    },
    data () {
        return {
        }
    },
    methods: {

    }
}
</script>

<style scoped>
    /*stylesheets*/
</style>



// WEBPACK FOOTER //
// faq.vue?7d0bf843